<template>
  <div class="box">
    <div class="txt">
      <div class="title">文旦安心保--浙江省玉环市地方财政补贴型文旦种植低温指数保险条款</div>
      <div class="subtitle">总则</div>
      <div class="paragraph">
        第一条 本保险合同由保险条款、投保单、保险单或其他保险凭证以及批单组成。凡涉及本保险合同的约定，均应采用书面形式。
      </div>
      <div class="paragraph">
        第二条 本保险合同的被保险人必须为在浙江省玉环市内从事文旦种植的种植户、合作社或企业。
      </div>
      <div class="subtitle">保险标的</div>
      <div class="paragraph">
        第三条 同时符合下列条件的文旦可作为本保险合同的保险标的（以下统称“保险文旦”），投保人应将符合下述条件的文旦全部投保，不得选择投保：
      </div>
      <div class="paragraph">
        （一）文旦种植区连片集中，产地环境条件符合农业行业标准；
      </div>
      <div class="paragraph">
        （二）连片种植面积10亩（含）以上，且树龄3年（含）以上；种植规模未达到10亩的种植户，可经村经济合作社统一组织后投保；
      </div>
      <div class="subtitle">责任免除</div>
      <div class="paragraph">第五条 下列原因造成的损失、费用，保险人不负责赔偿：</div>
      <div class="paragraph">（一）他人的恶意破坏行为，或投保人及其家庭成员、被保险人及其家庭成员、投保人或被保险人雇用人员的故意或重大过失行为、管理不善；</div>
      <div class="paragraph">
        （二）行政行为或司法行为；
      </div>
      <div class="paragraph">
        （三）战争、敌对行动、军事行动、武装冲突、罢工、骚乱、暴动、政变、谋反、恐怖活动；
      </div>
      <div class="paragraph">
        （四）地震、海啸及其次生灾害；
      </div>
      <div class="paragraph">
        （五）核辐射、核裂变、核聚变、核污染及其他放射性污染。
      </div>
      <div class="paragraph">
        第六条 下列损失、费用，保险人也不负责赔偿：
      </div>
      <div class="paragraph">
        （一）因低温以外的原因导致保险文旦的损失;
      </div>
      <div class="paragraph">
        （二）未达到本保险合同约定的低温赔付标准情况下的损失;
      </div>
      <div class="paragraph">
        （三）被保险人的各种间接损失；
      </div>
      <div class="paragraph">
        （四）根据本条款其他部分内容中的相关约定，保险人应不承担或免除保险责任的各种情形下的损失、费用或责任，或保险人有权予以扣除、减少的部分。
      </div>
      <div class="paragraph">
        （五）其他不属于本保险责任范围的损失、费用。
      </div>
      <div class="subtitle">保险责任</div>
      <div class="paragraph">
        第四条 在保险期间内，当保险文旦所在投保地理区域内根据约定气象站监测的气温数据计算得到的低温指数小于等于-2℃时，视为发生保险事故，保险人按照本保险合同约定负责赔偿。
      </div>
      <div class="paragraph">
        热带气旋影响的判断依据以当地气象台发布的台风预警信号为准。热带气旋影响起止时间以当地气象台发布和解除台风预警信号的时间为准。
      </div>
      <div class="subtitle">保险期间</div>
      <div class="paragraph">
        第七条 除另有约定外，本保险合同的保险期间自12月1日至次年3月31日，具体以保险合同载明的起讫时间为准。
      </div>
      <div class="subtitle">保险金额</div>
      <div class="paragraph">
        第八条 保险文旦每亩保险金额参照文旦生长期间所发生的成本确定为3000元，若当地政府对保险金额另有规定，以当地政府文件为准，并在保险单中载明。保险金额=每亩保险金额（元/亩）×保险面积（亩）.保险面积以保险单载明为准。
      </div>
      <div class="subtitle">保险费</div>
      <div class="paragraph">
        第九条 保险费=保险金额×保险费率
      </div>
      <div class="subtitle">保险人义务</div>
      <div class="paragraph">
        第十条
        订立本保险合同时，采用保险人提供的格式条款的，保险人向投保人提供的投保单应当附格式条款，保险人应向投保人说明本保险合同的条款内容。对保险合同中免除保险人责任的条款，保险人在订立保险合同时应当在投保单、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容以书面或者口头形式向投保人作出明确说明。未作提示或者明确说明的，该条款不产生效力。
      </div>
      <div class="paragraph">
        第十一条 本保险合同成立后，保险人应当及时向投保人签发保险单或其他保险凭证。
      </div>
      <div class="paragraph">
        第十二条 保险人依据本保险条款第十五条所取得的保险合同解除权，自保险人知道有解除事由之日起，超过三十日不行使而消灭。保险人在保险合同订立时已经知道投保人未如实告知的情况的，保险人不得解除保险合同；发生保险事故的，保险人应当承担赔偿责任。
      </div>
      <div class="paragraph">
        第十三条 保险人按照本保险条款第十八条的约定，认为被保险人提供的有关索赔的证明和资料不完整的，应当及时一次性通知被保险人补充提供。
      </div>
      <div class="paragraph">
        第十四条
        保险人收到被保险人的赔偿请求后，应当及时就是否属于保险责任作出核定，并将核定结果通知被保险人。情形复杂的，保险人在收到被保险人的赔偿请求后三十日内未能核定保险责任的，保险人与被保险人根据实际情形商议合理期间，保险人在商定的期间内作出核定结果并通知被保险人。对属于保险责任的，在与被保险人达成有关赔偿金额的协议后十日内，履行赔偿义务。
      </div>
      <div class="paragraph">
        保险人依照前款的约定作出核定后，对不属于保险责任的，应当自作出核定之日起三日内向被保险人发出拒绝赔偿保险金通知书，并说明理由。
      </div>
      <div class="subtitle">投保人、被保险人义务</div>
      <div class="paragraph">
        第十五条 投保人应履行如实告知义务，如实回答保险人就保险文旦或被保险人的有关情况提出的询问，并如实填写投保单。
      </div>
      <div class="paragraph">
        投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除保险合同。保险合同自保险人的解约通知书到达投保人或被保险人时解除。
      </div>
      <div class="paragraph">
        投保人故意不履行如实告知义务的，保险人对于保险合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
      </div>
      <div class="paragraph">
        投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于保险合同解除前发生的保险事故，不承担赔偿责任，但应当退还保险费。
      </div>
      <div class="paragraph">
        第十六条 除另有约定外，投保人应在保险合同成立时交清其自负部分的保险费。投保人自负部分的保险费交清前发生的保险事故，保险人不承担赔偿责任。
      </div>
      <div class="paragraph">
        第十七条 保险文旦转让的，被保险人或者受让人应当及时通知保险人。
      </div>
      <div class="paragraph">
        第十八条 被保险人向保险人请求赔偿时，应向保险人提供下列证明和资料：
      </div>
      <div class="paragraph">
        （一）保险单正本或保险凭证；
      </div>
      <div class="paragraph">
        （二）索赔申请书。
      </div>
      <div class="paragraph">
        被保险人未履行前款约定的义务，导致保险人无法核实损失情况的，保险人对无法核实的部分不承担赔偿责任。
      </div>
      <div class="paragraph">
        第十九条 被保险人在请求赔偿时应当如实向保险人说明与受损保险文旦有关的其他保险合同的情况。
      </div>
      <div class="subtitle">
        赔偿处理
      </div>
      <div class="paragraph">
        第二十条 保险事故发生时，被保险人对保险文旦不具有保险利益的，不得向保险人请求赔偿保险金。
      </div>
      <div class="paragraph">
        第二十一条 在保险单约定的投保地理区域内，保险文旦发生保险责任范围内的损失，保险人按以下方式计算赔偿：
      </div>
      <div class="image">
        <img src="@/assets/images/table3.jpg" alt="" />
      </div>
      <div class="paragraph">
        备注：气象站K8515对应的低温指数的备份值为气象站K8520计算得出的低温指数减去1.5℃。
      </div>
      <div class="paragraph">
        （二）本保险合同仅根据保险期间内最低一次低温指数对应的赔偿金额进行赔付；
      </div>
      <div class="paragraph">
        不同低温指数对应的单位赔偿金额
      </div>
      <div class="image">
        <img src="@/assets/images/table4.jpg" alt="" />
      </div>
      <div class="paragraph">
        赔偿金额=投保地理区域内最低一次低温指数对应的单位赔偿金额（元/亩）×保险面积（亩）
      </div>
      <div class="paragraph">
        任何情况下，总赔偿金额不得超过保险金额。
      </div>
      <div class="paragraph">
        第二十二条 若保险期间内发生保险事故，保险人将及时通知被保险人，并向其公布气象部门发布的约定气象站的气象观测数据，同时指导被保险人办理相关理赔手续。
      </div>
      <div class="paragraph">
        第二十三条 被保险人如果对保险人提供的低温指数统计及赔偿计算报告有异议，应当在收到报告后10日内，以书面报告的形式向保险人提出。如果被保险人没有在10日内向保险人提出异议，视为认可保险人提供的低温指数统计及赔偿计算报告。
      </div>
      <div class="paragraph">
        如果被保险人对气象数据的准确性有异议，应当向保险人提供有气象部门盖章确认的约定气象站观测的气象数据；如果被保险人对保险人的赔偿计算报告有异议，应当向保险人书面提出被保险人自己的赔偿计算报告，由保险人根据本保险合同约定的赔偿计算方式进行复核。
      </div>
      <div class="paragraph">
        第二十四条 保险事故发生时，如果存在重复保险，保险人按照本保险合同的相应保险金额与所有有关保险合同的相应保险金额总和的比例承担赔偿责任。
      </div>
      <div class="paragraph">
        其他保险人应承担的赔偿金额，本保险人不负责垫付。若被保险人未如实告知导致保险人多支付赔偿金的，保险人有权向被保险人追回多支付的部分。
      </div>
      <div class="paragraph">
        第二十五条 被保险人向保险人请求赔偿的诉讼时效期间为二年，自其知道或者应当知道保险事故发生之日起计算。
      </div>
      <div class="subtitle">
        争议处理和法律适用
      </div>
      <div class="paragraph">
        第二十六条 因履行本保险合同发生的争议，由当事人协商解决。协商不成的，提交保险合同载明的仲裁机构仲裁；保险合同未载明仲裁机构或者争议发生后未达成仲裁协议的，依法向人民法院起诉。
      </div>
      <div class="paragraph">
        第二十七条 与本保险合同有关的以及履行本保险合同产生的一切争议，适用中华人民共和国法律（不包括港澳台地区法律）。
      </div>
      <div class="subtitle">
        其他事项
      </div>
      <div class="paragraph">
        第二十八条 本保险合同自成立时起生效。
      </div>
      <div class="paragraph">
        第二十九条 保险责任开始前，投保人要求解除保险合同的，保险人将已收取的保险费退还投保人；保险责任开始后，投保人要求解除保险合同的，保险人对保险责任开始之日起至保险合同解除之日止期间的保险费，按日比例计收，剩余部分退还投保人。
      </div>
      <div class="paragraph">
        除另有约定外，保险人要求解除保险合同的，应提前十五日向投保人发出解约通知书，保险人按照保险责任开始之日起至保险合同解除之日止期间与保险期间的日比例计收保险费，并退还剩余部分保险费。
      </div>
      <div class="paragraph">
        但在保险合同有效期内，投保人、保险人均不得因保险文旦的危险程度发生变化增加保险费或者解除本保险合同。
      </div>
      <div class="paragraph">
        第二十九条 保险责任开始前，投保人要求解除保险合同的，保险人将已收取的保险费退还投保人；保险责任开始后，投保人要求解除保险合同的，保险人对保险责任开始之日起至保险合同解除之日止期间的保险费，按日比例计收，剩余部分退还投保人。
      </div>
      <div class="paragraph">
        第三十条 保险文旦发生全部损失，属于保险责任的，保险人在履行赔偿义务后，本保险合同终止；不属于保险责任的，本保险合同终止，保险人按日比例计收自保险责任开始之日起至损失发生之日止期间的保险费，并退还剩余部分的保费。
      </div>
      <div class="paragraph">
        第三十一条 本保险合同约定与《中华人民共和国保险法》、《农业保险条例》等法律规定相悖之处，以法律规定为准。本保险合同未尽事宜，以法律规定为准。
      </div>
      <div class="subtitle">
        释义
      </div>
      <div class="paragraph">
        第三十二条 本保险合同涉及下列术语时，适用下列释义：
      </div>
      <div class="paragraph">
        （一）低温指数：在保险期间内，约定气象站逐日的低温指数由以下三项数值累加计算得到：
      </div>
      <div class="paragraph">
        ①日最低气温值；
      </div>
      <div class="paragraph">
        ②若日平均气温低于0℃，此项数值为日平均气温的三分之一值（四舍五入，保留小数点后一位）；若日平均气温高于或等于0℃，此项数值为零；
      </div>
      <div class="paragraph">
        ③保险期间内日最低气温分别低于或等于-2℃、-2.5℃、-3℃的天数，对应着不同的低温附加值（详见下表）；此项数值为保险期间内绝对值最大的低温附加值。
      </div>
      <div class="paragraph">
        不同日最低气温级别下低温天数对应的低温附加值
      </div>
      <div class="image">
        <img src="@/assets/images/table5.jpg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {}
  }
}
</script>

<style lang="stylus" scoped>
body{
  width: 100%
  .box{
    height: 100vh
    overflow-y: scroll
    padding: 30px
    .txt{
        text-align: left
        font-size: 24px
        .subtitle{
          margin-top: 15px;
          font-weight: bold
        }
        .title{
          font-size: 32px
          text-align: center
          font-weight: bold
          margin-bottom: 20px
        }
        .paragraph{
          text-indent: 2em
        }
      }
  }
}
</style>
